import React, { useState } from 'react';
import { hpColor } from '../../themes/palettes';
import { CharacterAvatar } from '../primitives/CharacterAvatar';
import { CalmStat } from './CalmStat';

export const CalmCharacter = ({ char, palette, bodyFont, headingFont, theme, onContinue, onRemove }) => {
  const c = theme.colors;
  const [hover, setHover] = useState(false);
  const canContinue = typeof onContinue === 'function';
  const canRemove = typeof onRemove === 'function';

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gap: 18,
      alignItems: 'center',
    }}>
      <div style={{
        width: 56, height: 56,
        borderRadius: 8,
        background: 'rgba(255,255,255,0.03)',
        border: `1px solid ${palette.color}55`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        overflow: 'hidden',
      }}>
        <CharacterAvatar char={char} size={56} color={palette.light} fontFamily={headingFont} />
      </div>

      <div style={{ minWidth: 0 }}>
        <div style={{
          display: 'flex', alignItems: 'baseline', gap: 10,
          marginBottom: 2,
        }}>
          <span style={{
            fontFamily: headingFont,
            fontSize: '1.3rem',
            fontWeight: 600,
            color: c.textPrimary,
            letterSpacing: 0,
          }}>{char.name}</span>
          {char.isTestCharacter && (
            <span style={{
              fontFamily: bodyFont,
              fontSize: '0.62rem',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: palette.light,
              border: `1px solid ${palette.color}88`,
              borderRadius: 999,
              padding: '1px 7px',
            }}>Practice</span>
          )}
          <span style={{
            fontFamily: bodyFont,
            fontSize: '0.78rem',
            color: c.textMuted,
          }}>{char.race} {char.cls} - Level {char.level}</span>
        </div>
        {char.note && (
          <div style={{
            fontFamily: bodyFont,
            fontSize: '0.78rem',
            color: c.warning,
            opacity: 0.85,
            marginBottom: 8,
            fontStyle: 'italic',
          }}>{char.note}</div>
        )}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 14,
          maxWidth: 360,
          marginTop: char.note ? 0 : 6,
        }}>
          <CalmStat
            label="HP"
            current={char.hp} max={char.maxHp}
            color={hpColor(char.hp, char.maxHp, theme)}
            bodyFont={bodyFont} c={c}
          />
          {char.mp != null && (
            <CalmStat
              label="MP"
              current={char.mp} max={char.maxMp}
              color={c.mana || c.info}
              bodyFont={bodyFont} c={c}
            />
          )}
        </div>
      </div>

      {canContinue || canRemove ? (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          {canContinue && (
            <button
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              onClick={onContinue}
              style={{
                padding: '9px 16px',
                background: hover ? palette.light : palette.color,
                border: 'none',
                borderRadius: 6,
                color: c.textOnAccent,
                fontFamily: bodyFont,
                fontSize: '0.86rem',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'background 150ms ease',
                whiteSpace: 'nowrap',
              }}
            >Continue</button>
          )}
          {canRemove && (
            <button
              type="button"
              onClick={onRemove}
              style={{
                padding: '9px 16px',
                background: 'transparent',
                border: `1px solid ${c.danger || '#d85c5c'}88`,
                borderRadius: 6,
                color: c.danger || '#ff8f8f',
                fontFamily: bodyFont,
                fontSize: '0.86rem',
                fontWeight: 600,
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              Remove
            </button>
          )}
        </div>
      ) : (
        <span style={{
          padding: '6px 10px',
          border: `1px solid ${c.borderLight}`,
          borderRadius: 6,
          color: c.textMuted,
          fontFamily: bodyFont,
          fontSize: '0.78rem',
          whiteSpace: 'nowrap',
        }}>Roster</span>
      )}
    </div>
  );
};
